<template>
  <b-card title="ویرایش کد تخفیف جدید">
    <b-form >
      <b-row>
        <b-col cols="6">


          <b-form-group
              label="کد تخفیف"
          >
            <b-form-input
                id="v-category-name"
                placeholder="کد تخفیف را وارد کنید"
                v-model="postData.code"
            />
          </b-form-group>


          <b-form-group
              label="کد تعداد دفعات قابل استفاده"
          >
            <b-form-input
                id="v-category-name"
                v-model="postData.numberOfConsumption"
            />
          </b-form-group>


          <b-form-group
              label="تاریخ انقضا"
          >
<!--            <b-form-input-->
<!--                placeholder="مدت زمان اشتراک را به صورت ماهانه وارد کنید"-->
<!--                v-model="postData.expireDate" type="number"-->

<!--            />-->
            <date-picker  type="datetime"  v-model="postData.expireDate" />
          </b-form-group>


        </b-col>
        <b-col cols="6" >
          <img src="../../../assets/images/discount.png" >
        </b-col>


        <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              @click="editDiscountCode"
              variant="warning"
          >
            ثبت
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BImg,
  BFormSelect,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BFormRadio,
  BLink,
  BCard,
  BRow,
  BCardBody
} from "bootstrap-vue";
import Croppa from 'vue-croppa'
import Vue from "vue";
import categoryRepository from "@/modules/categories/services/categoryRepository";
import axios from "@/libs/axios";
import Swal from 'sweetalert2'
import {$themeConfig} from "@themeConfig";
import uploadService from "@/modules/services/uploadService";
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import Image from "@/views/components/image/Image";
import subscriptionRepository from "@/modules/subscriptions/services/subscriptionRepository";
import discountRepository from "@/modules/discount/services/discountRepository";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import router from "@/router";
import {$appConfig} from "../../../../appConfig";
import moment from "jalali-moment";

Vue.use(Croppa);
export default {
  name: "addCategories",
  created() {
    this.discountId = router.currentRoute.params.id
    this.getDiscountCodeById()
  },
  components: {
    Image,
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BCardText,
    BImg,
    BFormRadio,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    videoFormComponent,
    datePicker: VuePersianDatetimePicker
  },
  data(){
    return {
      discountId:'',
      postData:{
        code: undefined,
        disposable: true,
        expireDate: undefined,
        general: true,
        numberOfConsumption: 0,
        status: true
      }
    }
  },
  methods: {
  async  editDiscountCode(){

     if (this.postData.code  && this.postData.expireDate && this.postData.numberOfConsumption){

       this.postData.expireDate = new Date(this.postData.expireDate)






         const {data} = await discountRepository.create(this.postData);
         if (data.isSuccess){
           await Swal.fire({
             confirmButtonText: 'ok',
             title : 'موفقیت',
             html : 'عملیات با موفقیت انجام شد',
             icon: 'success'
           } );
           await this.$router.replace('/discount/list')
         }else {
           await Swal.fire('هشدار', data.message, 'warning');
         }
       }else {
          await  Swal.fire('خطا' , ' نیاز است که فیلد های اجباری را پر کنید' , 'error')

       }





    },
    async getDiscountCodeById(){
      const { data } = await discountRepository.getById(`/${this.discountId}?discountCodeID =${this.discountId}`)
      console.log(data)

      if (data.isSuccess) {
        this.postData.code = data.data.code
        this.postData.disposable = data.data.disposable
        this.postData.expireDate = moment(data.data.expireDate, 'YYYY/M/D');
        this.postData.general = data.data.general
        this.postData.numberOfConsumption = data.data.numberOfConsumption
        this.postData.status = data.data.status

      }


    }

  }
}
</script>

<style scoped>


.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

</style>
